var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card mb-0 px-4 py-3 h-100",staticStyle:{"min-width":"450px","min-height":"289px"}},[_c('div',{staticClass:"competition-wordcloud h-100",attrs:{"id":"competitionwc"}})])
}]

export { render, staticRenderFns }